export const applyVat = (taxable, vat, decimalPosition) => {
    try{
        return Number(((Number(taxable) * Number(vat)) / 100) + Number(taxable)).toFixed(decimalPosition);
    }
    catch{
        return 0;
    }

}